import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const Colors = ({ data }) => {
  const i18n = useContext(I18nContext);
  const colorsText = (data?.length || 0)
    ? data.map(color => color.Asset.Text.toUpperCase()).join()
    : i18n.getString(_TL_('No colors'));

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Colors') }}>
      <Text>{colorsText}</Text>
    </PropertyRow>
  );
};

Colors.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    Asset: PropTypes.shape({
      Text: PropTypes.string,
    }),
  })),
};

Colors.defaultProps = {
  data: [],
};
